import React, { Component } from "react";

class DropDown extends Component {
  constructor(props) {
    super(props);

    // Set up the state here
    this.state = {
      open: false,
      selectedItem: null,
    };

    let selectedItems = props.items.filter((item) => item.selected);
    if (selectedItems.length) {
      this.state.selectedItem = selectedItems[0];
    }

    this.bindThis();
  }

  bindThis() {
    // Make 'this' work in event functions
    this.dropDownClicked = this.dropDownClicked.bind(this);
    this.dropDownItemClicked = this.dropDownItemClicked.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({
        open: false,
      });
    }
  }

  dropDownClicked() {
    this.toggleOpen();
  }

  dropDownItemClicked(item) {
    this.props.items.forEach((listItem) => {
      listItem.selected = false;
    });

    item.selected = true;
    this.setState({
      selectedItem: item,
    });

    this.toggleOpen();
    this.props.onItemSelected && this.props.onItemSelected(item);
  }

  toggleOpen() {
    this.setState({
      open: !this.state.open,
    });
  }

  render() {
    return (
      <div ref={this.setWrapperRef} className="c-filter-dropdown">
        <button
          onClick={this.dropDownClicked}
          className={
            this.state.open
              ? "c-filter-dropdown__select c-filter-dropdown__select--open"
              : "c-filter-dropdown__select"
          }
        >
          {this.state.selectedItem
            ? this.state.selectedItem.text
            : this.props.title}
            <i className="icon-keyboard_arrow_down"></i>
        </button>
        <div className="c-filter-dropdown__list">
          {this.props.items.map((item) => {
            return (
              <div
                className={
                  item.selected
                    ? "c-filter-dropdown__list-item c-filter-dropdown__list-item--active"
                    : "c-filter-dropdown__list-item"
                }
                key={item.value}
              >
                <label htmlFor={item.value}>
                  {item.text}
                  <input
                    type="radio"
                    id={item.value}
                    name={item.value}
                    value={item.value}
                    onClick={() => this.dropDownItemClicked(item)}
                  />
                </label>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default DropDown;
